// Comprehensive freelance marketplace categories and sub-categories
export const GIG_CATEGORIES = {
  'graphics-design': {
    label: 'Graphics & Design',
    subCategories: [
      'logo-design',
      'brand-style-guides',
      'business-cards',
      'web-page-design',
      'landing-page-design',
      'social-media-design',
      'photo-editing',
      'illustration',
      'infographic-design',
      'banner-ads',
      '3d-modeling',
      'vector-tracing',
      'image-optimization',
      'other-graphics-design'
    ]
  },
  'digital-marketing': {
    label: 'Digital Marketing',
    subCategories: [
      'social-media-marketing',
      'content-marketing',
      'seo',
      'search-engine-marketing',
      'marketing-strategy',
      'public-relations',
      'email-marketing',
      'marketing-automation',
      'web-analytics',
      'conversion-rate-optimization',
      'influencer-marketing',
      'video-marketing',
      'other-digital-marketing'
    ]
  },
  'writing-translation': {
    label: 'Writing & Translation',
    subCategories: [
      'articles-blog-posts',
      'website-content',
      'product-descriptions',
      'proofreading-editing',
      'creative-writing',
      'transcription',
      'resume-writing',
      'technical-writing',
      'translations',
      'scriptwriting',
      'press-releases',
      'white-papers',
      'other-writing-translation'
    ]
  },
  'video-animation': {
    label: 'Video & Animation',
    subCategories: [
      'whiteboard-animated-explainers',
      'video-editing',
      'video-ads',
      'music-videos',
      'subtitles-captions',
      'lyric-videos',
      'spokesperson-videos',
      'animation-for-kids',
      'brand-videos',
      'unboxing-videos',
      'visual-effects',
      'videographers',
      'other-video-animation'
    ]
  },
  'music-audio': {
    label: 'Music & Audio',
    subCategories: [
      'voice-overs',
      'mixing-mastering',
      'producers-composers',
      'singers-vocalists',
      'podcast-production',
      'audiobook-production',
      'jingle-intro',
      'audio-editing',
      'songwriters',
      'music-lessons',
      'other-music-audio'
    ]
  },
  'programming-tech': {
    label: 'Programming & Tech',
    subCategories: [
      'website-development',
      'mobile-app-development',
      'desktop-app-development',
      'game-development',
      'chatbot-development',
      'ecommerce-development',
      'qa-testing',
      'wordpress',
      'shopify',
      'bug-fixes',
      'database-design',
      'api-integration',
      'other-programming-tech'
    ]
  },
  'business': {
    label: 'Business',
    subCategories: [
      'virtual-assistant',
      'market-research',
      'business-plans',
      'business-consulting',
      'financial-consulting',
      'legal-consulting',
      'presentation-design',
      'lead-generation',
      'data-entry',
      'project-management',
      'hr-consulting',
      'other-business'
    ]
  },
  'lifestyle': {
    label: 'Lifestyle',
    subCategories: [
      'online-tutoring',
      'fitness-training',
      'nutrition-advice',
      'beauty-advice',
      'relationship-advice',
      'life-coaching',
      'astrology-psychics',
      'travel-planning',
      'career-counseling',
      'personal-styling',
      'other-lifestyle'
    ]
  },
  'data': {
    label: 'Data',
    subCategories: [
      'data-analysis',
      'data-visualization',
      'data-engineering',
      'data-science',
      'machine-learning',
      'ai-consulting',
      'big-data',
      'data-mining',
      'statistical-analysis',
      'other-data'
    ]
  },
  'photography': {
    label: 'Photography',
    subCategories: [
      'product-photography',
      'real-estate-photography',
      'event-photography',
      'fashion-photography',
      'food-photography',
      'portrait-photography',
      'photo-retouching',
      'drone-photography',
      'stock-photography',
      'other-photography'
    ]
  },
  'online-marketing': {
    label: 'Online Marketing',
    subCategories: [
      'seo-services',
      'social-media-management',
      'google-ads',
      'facebook-ads',
      'instagram-marketing',
      'linkedin-marketing',
      'twitter-marketing',
      'tiktok-marketing',
      'youtube-marketing',
      'pinterest-marketing',
      'other-online-marketing'
    ]
  },
  'translation': {
    label: 'Translation',
    subCategories: [
      'general-translation',
      'legal-translation',
      'medical-translation',
      'technical-translation',
      'website-localization',
      'subtitling',
      'transcription',
      'other-translation'
    ]
  },
  'other': {
    label: 'Other',
    subCategories: [
      'general-consulting',
      'research',
      'data-entry',
      'online-education',
      'other-services'
    ]
  }
};

export const JOB_CATEGORIES = { ...GIG_CATEGORIES };

// Helper function to format category names
export const formatCategoryName = (category) => {
  return category
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// Helper function to format sub-category names
export const formatSubCategoryName = (subCategory) => {
  return subCategory
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
